import { useCallback } from 'react'
import axios from 'axios'

const useRatingClient = () => {
  const sendFeedBack = useCallback((values) => axios.post('/IndecX/answer', values), [])

  const getFeedBack = useCallback(() => axios.get('/IndecX/today')
    .then((response) => response?.data), [])

  return useCallback(() => ({
    getFeedBack,
    sendFeedBack,
  }), [
    getFeedBack,
    sendFeedBack,
  ])
}

export default useRatingClient
